import {
  GET_BOOKING,
  GET_BOOKING_FAILED,
  GET_BOOKING_LOADING,
  GET_BOOKING_REQUIRED_DATA,
  GET_BOOKING_REQUIRED_DATA_SUCCESS,
  GET_BOOKING_SUCCESS,
  GET_TICKET_CUSTOMER_DATA_CHANGES_SUCCESS,
  UPDATE_BOOKING_RESALE,
  UPDATE_BOOKING_RESALE_FAILED,
  UPDATE_BOOKING_RESALE_SUCCESS,
} from './types';

import requiredDataReducer from './requiredDataReducer';

const initialState = {
  updating: false,
  loading: {},
  required: {},
};

const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BOOKING:
      return {
        ...state,
      };

    case GET_BOOKING_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.booking_ref]: action.payload.isLoading,
        },
      };

    case GET_BOOKING_SUCCESS:
      return {
        ...state,
        [action.payload.booking.reference]: action.payload.booking,
        loading: {
          ...state.loading,
          [action.payload.booking.reference]: false,
        },
      };

    case GET_BOOKING_FAILED:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.booking_ref]: false,
        },
      };
    case GET_BOOKING_REQUIRED_DATA:
    case GET_BOOKING_REQUIRED_DATA_SUCCESS:
      return {
        ...state,
        required: requiredDataReducer(state.required, action),
      };
    case UPDATE_BOOKING_RESALE:
      return {
        ...state,
        updating: true,
      };
    case UPDATE_BOOKING_RESALE_SUCCESS:
    case UPDATE_BOOKING_RESALE_FAILED:
      return {
        ...state,
        updating: false,
      };
    case GET_TICKET_CUSTOMER_DATA_CHANGES_SUCCESS:
      return {
        ...state,
        [action.payload.bookingRef]: {
          ...state[action.payload.bookingRef],
          ticketCustomerDataChanges: action.payload.ticketCustomerDataChanges,
        },
      };
    default:
      return state;
  }
};

export default bookingReducer;
